import { render, staticRenderFns } from "./PgDetail.vue?vue&type=template&id=dd5c5ed4&scoped=true&"
import script from "./PgDetail.vue?vue&type=script&lang=js&"
export * from "./PgDetail.vue?vue&type=script&lang=js&"
import style0 from "./PgDetail.vue?vue&type=style&index=0&id=dd5c5ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5c5ed4",
  null
  
)

export default component.exports